<template>
  <div>
    <h2 class="mb-4">{{ defaultHeader }}</h2>

    <div class="row no-gutters">
      <BlockContainer class="col p-4 mt-4">
        <div class="d-flex align-items-center">
          <i class="h3 budicon-location-pin" />
          <h5 class="ml-4">Leieobjektet</h5>
        </div>
        <p class="mt-3">
          I Leieobjektet registrerer du boligens adresseinformasjon, egenskaper (størrelse, oppvarming etc),
          husordensregler, fasiliteter (aircondition, garasje etc) og romfordeling. Noen av punktene gjenbrukes i
          kontrakter og/eller annonser.
        </p>
        <div class="d-flex justify-content-center mt-5">
          <button
            class="btn btn-sm btn-outline-secondary d-flex align-items-center"
            @click="goToRoute('rentalObject_details')"
          >
            Leieobjektet
            <i class="ml-2 budicon-arrow-right" />
          </button>
        </div>
      </BlockContainer>
      <BlockContainer class="col p-4 mt-4 ml-4">
        <div class="d-flex align-items-center">
          <i class="h3 budicon-announcement" />
          <h5 class="ml-4">Leietakersøk (annonser)</h5>
        </div>
        <p class="mt-3">
          I Leietakersøk finner du aktive og avsluttede annonser og dets interessenter. Du kan publisere nye og redigere
          aktive annonser, og du kan administrere interessentene til boligen, inkludert kredittsjekking. Merk at
          annonser som publiseres blir synlige neste virkedag før kl 09.
        </p>
        <div class="d-flex justify-content-center mt-5">
          <button
            class="btn btn-sm btn-outline-secondary d-flex align-items-center"
            @click="goToRoute('rentalObject_ads')"
          >
            Leietakersøk
            <i class="ml-2 budicon-arrow-right" />
          </button>
        </div>
      </BlockContainer>
    </div>
    <div class="row no-gutters">
      <BlockContainer class="col p-4 mt-4">
        <div class="d-flex align-items-center">
          <i class="h3 budicon-shared-user" />
          <h5 class="ml-4">Leieforhold</h5>
        </div>
        <p class="mt-3">
          I Leieforhold finner du oversikt over nåværende og tidligere leietakere til denne spesifikke boligen.
        </p>
        <div class="d-flex justify-content-center mt-5">
          <button
            class="btn btn-sm btn-outline-secondary d-flex align-items-center"
            @click="goToRoute('rentalObject_tenancies')"
          >
            Leieforhold
            <i class="ml-2 budicon-arrow-right" />
          </button>
        </div>
      </BlockContainer>
      <BlockContainer class="col p-4 mt-4 ml-4">
        <div class="d-flex align-items-center">
          <i class="h3 budicon-attachment" />
          <h5 class="ml-4">Dokumenter</h5>
        </div>
        <p class="mt-3">
          I Dokumenter finner du kopi av alle fullførte leiekontrakter og overtakelsesprotokoller som er opprettet for
          denne spesifikke boligen.
        </p>
        <div class="d-flex justify-content-center mt-5">
          <button
            class="btn btn-sm btn-outline-secondary d-flex align-items-center"
            @click="goToRoute('rentalObject_documents')"
          >
            Dokumenter
            <i class="ml-2 budicon-arrow-right" />
          </button>
        </div>
      </BlockContainer>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import BlockContainer from '@/components/BlockContainer.vue';
import InfoCard from '@/components/InfoCard.vue';

export default Vue.extend({
  name: 'RentalObjectOverview',
  props: {
    landlordId: {
      type: String,
      required: true,
    },
    rentalObjectId: {
      type: String,
      required: true,
    },
    defaultHeader: {
      type: String,
      required: true,
    },
  },
  components: {
    BlockContainer,
    InfoCard,
  },
  methods: {
    goToRoute(routeName) {
      this.$router.push({
        name: routeName,
        params: {
          landlordId: this.landlordId,
        },
      });
    },
  },
});
</script>
